import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22JetBrains_Mono%22,%22arguments%22:[{%22display%22:%22optional%22,%22fallback%22:[%22ui-monospace%22,%22SFMono-Regular%22,%22monospace%22],%22preload%22:false,%22subsets%22:[%22latin%22],%22variable%22:%22--font-geist-mono%22}],%22variableName%22:%22geistMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
